import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";


export const ActivityLogsLayout = () => {


    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListActivityLogs}>
                    <IndexPage/></RestrictedRouteElement>}
            />
        </Routes>
    );
};
